import React from 'react'
import styles from './../index.module.sass'


interface Props {
  settedRef: React.RefObject<HTMLDivElement>,
  show: boolean,
  reverse?: Boolean
}

const Data = {
  d: 'm 57.022734,28.540272 c -10.35812,51.48598 1.305562,119.816058 25.590344,164.477518 5.30206,10.37172 0.09098,25.58783 -11.733142,31.82997 -13.727642,7.24906 -28.369652,2.43681 -36.269232,-11.78068 C 7.433984,158.66028 -8.495616,87.641782 6.614214,23.618672 c 3.00716,-10.43444 7.60527,-16.7005498 16.47262,-20.4546798 15.0308,-6.75099 36.197867,4.86664 33.9359,25.3762798 z M 76.340813,192.69973 C 70.8093,181.88069 60.264279,178.45637 49.474184,183.97335 c -10.79134,5.51634 -14.18888,16.06958 -8.65832,26.88892 5.53121,10.81809 16.07623,14.24241 26.866625,8.72638 10.791044,-5.51729 14.18858,-16.07053 8.658324,-26.88892 z',
  d_reverse: 'M 28.435942,200.89068 C 38.794061,149.4047 27.130376,81.074618 2.8455947,36.413161 -2.4564654,26.041438 2.7546125,10.825331 14.578736,4.5831979 28.306377,-2.6658643 42.948387,2.1463856 50.847968,16.363874 78.024687,70.770672 93.95429,141.78917 78.844461,205.81228 c -3.007167,10.43444 -7.605276,16.70055 -16.47262,20.45468 -15.030801,6.75099 -36.19787,-4.86664 -33.935899,-25.37628 z M 9.1178591,36.731225 C 14.649372,47.550264 25.194393,50.974586 35.984484,45.4576 46.775833,39.941261 50.173369,29.388022 44.642808,18.568678 39.111601,7.7505912 28.56658,4.3262694 17.776183,9.8423032 6.9851397,15.359594 3.5876036,25.912833 9.1178591,36.731225 Z'
}

const LeversTrack: React.FC<Props> = ({ settedRef, show, reverse }) => {
  return (
    <div 
      ref={settedRef}
      className={`${ show ? styles.levers_active : ''} ${styles.levers}`}>
      <svg 
        width="50px" 
        height="250px" 
        version="1.1" 
        className='tsvg'
        xmlns="http://www.w3.org/2000/svg"
      >
        <path 
          id="startpath" 
          d={reverse ? Data.d_reverse : Data.d} 
          // stroke="gray" 
          // strokeDasharray="5,5"
          fill="white"
        />
        <path 
          id="endpath" 
          d={reverse ? Data.d_reverse : Data.d} 
          // strokeWidth="7"
          // stroke="#7CFC00" 
          fill="transparent" 
          strokeLinecap="round"
        />
        {
          reverse ?
            <ellipse 
            xmlns="http://www.w3.org/2000/svg" 
            id="path1725" 
            cx="27.533901" 
            cy="28.016951" 
            rx="23.737289" 
            fill="#80d1a8"
            ry="23"/>
            :
            null
        }
        <path className='svgtarget' xmlns="http://www.w3.org/2000/svg" fill="#80d1a8" fillRule="evenodd" d="M17.199 1.267C29.158-.694 38.155 5.785 40.121 17.776c1.965 11.99-4.491 21.003-16.451 22.964C11.711 42.7 2.714 36.221.748 24.231-1.217 12.24 5.239 3.227 17.199 1.267z"/>
        <circle 
          className={`knob ${styles.levers_knob}`}
          r="22" 
          fill="#01a451" 
        />
        <path id='leversPath' xmlns="http://www.w3.org/2000/svg" style={{opacity: 0}} d="m 25.118644,26.084746 c 0,0 16.692803,36.716208 22.220339,56.033898 C 52.291368,99.426291 55.184218,117.3438 57,135.25424 c 1.462037,14.42118 2.446223,29.05524 0.966102,43.47457 -0.877441,8.54802 -2.898305,23.18645 -2.898305,23.18645"/>
        <path id='leversPath2' xmlns="http://www.w3.org/2000/svg" style={{opacity: 0}} d="m 58.699765,201.91526 c 0,0 -16.692798,-36.71621 -22.220338,-56.0339 -4.95239,-17.30764 -7.84524,-35.22515 -9.66102,-53.135593 -1.46203,-14.42118 -0.514017,-28.089138 0.966103,-42.508468 0.87744,-8.54802 4.898311,-24.152552 4.898311,-24.152552"/>
      </svg>
    </div>
  )
}

export default LeversTrack
